import React from 'react'

const TiktokLinkPostGrid = (props) => {
    const { posts, selectedPosts, togglePostSelection } = props;
    return (
        <div className="grid grid-cols-2 gap-6">
            {posts.map((post) => (
                <div key={post.id} className="p-4 border rounded-lg shadow-md">
                    <h3 className="font-medium">{post.title}</h3>
                    <p>{post.description}</p>
                    <span>👍 {post.reactions}</span>
                </div>
            ))}
        </div>
    )
}

export default TiktokLinkPostGrid
